import { successfulConfirmComponent } from './successfulConfirm.component';
import { transferringStateName } from '../../../tickets.state';
import { TicketService } from '../../../../ticket/ticket.service';

export const successfulConfirmStateName = `${transferringStateName}.successfulConfirm`;

export const successfulConfirmState = ($stateProvider) => {
  'ngInject';

  $stateProvider.state({
    name: successfulConfirmStateName,
    url: '/request/success/:ticketId',
    component: successfulConfirmComponent.name,
    data: { requiresAuth: true },
    resolve: {
      ticket: TicketService.ticket(),
      stateIndex: () => 3
    }
  });
};
